import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { Language, SessionKey } from "../util/Constant";

import common_en from "./en/common.json";
import common_kh from "./kh/common.json";
import common_cn from "./zh/common.json";
import common_vi from "./vi/common.json";
import common_id from "./id/common.json";
import common_pt from "./pt/common.json";
import common_bn from "./bn/common.json";
import common_zh_hk from "./zh-HK/common.json";
import common_ur from "./ur/common.json";
import common_ne from "./ne/common.json";
import common_tpi from "./tpi/common.json";
import common_ho from "./ho/common.json";
import common_th from "./th/common.json";
import common_ms from "./ms/common.json";

import moment from "moment";
import "moment/locale/vi";
import "moment/locale/km";
import "moment/locale/zh-cn";
import "moment/locale/zh-hk";
import "moment/locale/id";
import "moment/locale/pt";
import "moment/locale/bn";
import "moment/locale/ur";
import "moment/locale/ne";
import "moment/locale/th";
import "moment/locale/ms";

/// <summary>
/// Author: -
/// </summary>
const _resources = {};
_resources[Language._ENGLISH] = { common: common_en };
_resources[Language._KHMER] = { common: common_kh };
_resources[Language._CHINESE] = { common: common_cn };
_resources[Language._VIETNAMESE] = { common: common_vi };
_resources[Language._INDON] = { common: common_id };
_resources[Language._PORTUGUESE] = { common: common_pt };
_resources[Language._BENGALI] = { common: common_bn };
_resources[Language._TRADITIONAL_CHINESE] = { common: common_zh_hk };
_resources[Language._URDU] = { common: common_ur };
_resources[Language._NEPALI] = { common: common_ne };
_resources[Language._TOK_PISIN] = { common: common_tpi };
_resources[Language._HIRI_MOTU] = { common: common_ho };
_resources[Language._THAI] = { common: common_th };
_resources[Language._MALAY] = { common: common_ms };

const _momentLocaleMap = {};
_momentLocaleMap[Language._ENGLISH] = "en";
_momentLocaleMap[Language._KHMER] = "km";
_momentLocaleMap[Language._CHINESE] = "zh-cn";
_momentLocaleMap[Language._VIETNAMESE] = "vi";
_momentLocaleMap[Language._INDON] = "id";
_momentLocaleMap[Language._PORTUGUESE] = "pt-br";
_momentLocaleMap[Language._BENGALI] = "bn";
_momentLocaleMap[Language._TRADITIONAL_CHINESE] = "zh-hk";
_momentLocaleMap[Language._URDU] ="ur";
_momentLocaleMap[Language._NEPALI] = "ne";
_momentLocaleMap[Language._TOK_PISIN] = "en";
_momentLocaleMap[Language._HIRI_MOTU] = "en";
_momentLocaleMap[Language._THAI] ="th";
_momentLocaleMap[Language._MALAY] ="ms";


if (window.ReactNativeWebView) {
	window.ReactNativeWebView.postMessage(
		JSON.stringify({
			action: "language",
			language: localStorage.getItem(SessionKey._LANGUAGE) || Language._ENGLISH,
		})
	);
}

i18n.use(initReactI18next).init({
	defaultNS: "common",
	debug: false,
	resources: _resources,
	lng: localStorage.getItem(SessionKey._LANGUAGE) || Language._ENGLISH,
	fallbackLng: [Language._ENGLISH],
	keySeparator: false,
	interpolation: {
		escapeValue: false, // react already safes from xss
	},
});

// Update moment locale whenever i18n language changes
i18n.on("languageChanged", (lng) => {
  const momentLang = _momentLocaleMap[lng] || Language._ENGLISH;
  moment.locale(momentLang);
});

export default i18n;
